export default __webpack_public_path__ + "static/media/close.d360a7cb.svg";